import { Button } from '@/components/ui/button';

import { useApplications } from '../model';

type Props = {
  onDone: () => void;
};

const FilterFooter = ({ onDone }: Props) => {
  const { clearAllFilters } = useApplications();

  return (
    <div className="flex items-center justify-between border-t p-2">
      <Button variant="link" size="sm" onClick={clearAllFilters}>
        Clear all
      </Button>
      <Button size="sm" onClick={onDone}>
        Done
      </Button>
    </div>
  );
};

export default FilterFooter;
